import AbstractManageable from "./abstract-manageable";
import Account from "./account";
import Instruction from "./instruction";
import User from "./user";

export default class Class extends AbstractManageable {
	/**
	 * 
	 * @param {Number} id 
	 * @param {String} number 
	 * @param {String} label 
	 * @param {String} description 
	 * @param {Instruction} instruction 
	 * @param {Account[]} accounts 
	 * @param {User} creator 
	 * @param {Date} createdAt 
	 * @param {User} updater 
	 * @param {Date} updatedAt 
	 */
	constructor(
			id,
			number,
			label,
			description,
			instruction,
			accounts,
			creator,
			createdAt,
			updater,
			updatedAt) {
		super(creator, createdAt, updater, updatedAt);
		this.id = id;
		this.number = number;
		this.label = label;
		this.description = description;
		this.instruction = instruction;
		this.accounts = accounts;
		this.creator = creator;
		this.createdAt = createdAt;
		this.updater = updater;
		this.updatedAt = updatedAt;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		const id = json.id;
		const number = json.number;
		const label = json.label;
		const description = json.description;
		const instruction = Instruction.createFromJson(json.instruction);
		const accounts = json.accounts && json.accounts.map(j => Account.createFromJson(j));
		const creator = User.createFromJson(json.creator);
		const createdAt = new Date(json.createdAt);
		const updater = User.createFromJson(json.updater);
		const updatedAt = new Date(json.updatedAt);

		return new Class(
			id,
			number,
			label,
			description,
			instruction,
			accounts,
			creator,
			createdAt,
			updater,
			updatedAt);
	}
}


// WEBPACK FOOTER //
// ./src/model/class.js